export type SurfaceAssetFilteredKindCounts = {
  byKind: ReadonlyMap<string, number>;
  total: number;
};

export const resolveSurfaceAssetKindCount = ({
  kind,
  filteredCounts,
  statsCount,
}: {
  kind: string | null;
  filteredCounts: SurfaceAssetFilteredKindCounts | null;
  statsCount: number;
}): number => {
  if (filteredCounts === null) {
    return statsCount;
  }

  return kind === null
    ? filteredCounts.total
    : (filteredCounts.byKind.get(kind) ?? 0);
};
